import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import TransportList01Actions, { TransportList01Types } from '../Stores/TransportList01/Actions';

const getAppStore = state => state.app;

export function* transportList01FetchTransportList01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(TransportList01Actions.transportList01FetchTransportList01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `transport/indexProcess/TRANSPORT_LIST_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        TransportList01Actions.transportList01FetchTransportList01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(TransportList01Actions.transportList01FetchTransportList01Loading(false));
  }
}

export function* transportList01GoToResource({ resId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/transportDetail/update/${resId}`));
}

export function* transportList01NewResource() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/transportDetail/create/${app.curSiteFlowId}`));
}

export const saga = [
  takeLatest(TransportList01Types.TRANSPORT_LIST01_GO_TO_RESOURCE, transportList01GoToResource),
  takeLatest(
    TransportList01Types.TRANSPORT_LIST01_FETCH_TRANSPORT_LIST01,
    transportList01FetchTransportList01
  ),
  takeLatest(TransportList01Types.TRANSPORT_LIST01_NEW_RESOURCE, transportList01NewResource)
];
